import { VStack } from "@chakra-ui/react";
import RoomMaterialSelector from "./RoomMaterialSelector";
import { useEffect } from "react";
import { handleZoomOnlyView } from "../../constants/Helpers";
import {
  useModelStore,
  useRoomStore,
  useUserInterfaceStore,
} from "../../store";

function RoomControlPanel() {
  const setEditingRoom = useUserInterfaceStore((s) => s.setEditingRoom);
  const setRoomEditingTab = useUserInterfaceStore((s) => s.setRoomEditingTab);
  const cameraControls = useModelStore((s) => s.cameraControls);
  const height = useRoomStore((s) => s.height);
  const scaleX = useRoomStore((s) => s.scaleX);
  const scaleZ = useRoomStore((s) => s.scaleZ);

  useEffect(() => {
    setEditingRoom(true);
    setRoomEditingTab(0); // Wall Type tab
    handleZoomOnlyView(cameraControls, height, scaleX, scaleZ);
  }, [cameraControls, height, scaleX, scaleZ, setEditingRoom, setRoomEditingTab]);

  return (
    <VStack spacing={4} align="stretch" width="100%">
      <RoomMaterialSelector />
    </VStack>
  );
}

export default RoomControlPanel;
